import styled from "styled-components";

export const GameClubMemberWrapper = styled.div`
  position: fixed;
  margin: 20px 16px;
  border-radius: 8px;
  background: #1f212799;
  width: 92%;
  paddding-bottom: 200px;
`;

export const GameClubMemberHeader = styled.div`
  padding: 20px 16px;
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const GameClubMemberHeaderItem = styled.div<{ width: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3.5px;
  max-width: ${(p) => p.width}%;
  min-width: ${(p) => p.width}%;

  > .rotate {
    transform: rotate(180deg);
    transition: transform 0.2s ease;
  }

  > .name {
    color: #ffffff;
    font-weight: 600;
    font-size: 11px;
  }
`;

export const GameClubMemberTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  padding: 0px 16px 150px;
  height: 600px;
  overflow-y: auto;
`;

export const GameClubMemberTableItem = styled.div`
  height: 60px;
  border-radius: 8px;
  width: 100%;
  padding: 10px;
  background: #ffffff0d;
  display: flex;
  align-items: center;
  gap: 10px;

  > div {
    color: #ffffff;
    font-weight: 500;
    font-size: 10px;
    text-align: center;

    &.count {
      min-width: 12%;
      max-width: 12%;
    }

    &.date {
      min-width: 20%;
      max-width: 20%;
    }
  }
`;

export const GameClubMemberTableItemMember = styled.div`
  min-width: 16%;
  max-width: 16%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 5px;

  > .name {
    font-weight: 700;
    font-size: 11px;
    text-align: left;
  }

  > .role {
    border-radius: 8px;
    background: #4b4c4f;

    font-weight: 700;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    width: 45px;
    padding: 2.5px 0;

    &.LEADER {
      background: #6436e7;
    }
  }
`;

export const GameClubMemberPaging = styled.div`
  gap: 12px;
  justify-content: center;
  display: flex;
  padding: 30px 0;

  > .pages {
    display: flex;
    gap: 12px;
    justify-content: center;

    > .page {
      width: 16px;
      height: 22px;

      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      color: #ffffff66;

      &.selected {
        color: #fff;
        font-weight: 700;
      }
    }
  }
`;
